export default "__VITE_ASSET__Dtfy01Z___"